// Editorial metadata for selected tags. Tags themselves stay a flat, lowercase,
// open vocabulary (see CLAUDE.md) — this is a small, optional presentation layer
// on top, exactly like COLLECTIONS is for the landing packages: it gives a tag a
// prettier display label and a one-line description, shown wherever the raw tag
// would otherwise appear (the detail inspector's chips, the active-filter bar).
// A tag with no entry simply shows its raw string, so this never has to list
// every tag — only the few worth explaining.

export interface TagMeta {
  /** A nicer display label shown in place of the raw tag ("fable" → "Generated by Fable"). */
  label: string;
  /** One-line explanation, shown as a chip tooltip and in the filter bar. */
  description: string;
}

export const TAG_META: Record<string, TagMeta> = {
  fable: {
    label: "Generated by Fable",
    description: "This model was generated by Anthropic's Fable AI model.",
  },
};

/** The metadata for `tag`, if any has been authored (case-insensitive). */
export function tagMeta(tag: string): TagMeta | undefined {
  return TAG_META[tag.toLowerCase()];
}

/** The label to display for `tag` — its pretty label if it has one, else the raw tag. */
export function tagLabel(tag: string): string {
  return tagMeta(tag)?.label ?? tag;
}
